import { Subject } from 'rxjs';
import { Injectable } from '@angular/core';

@Injectable()
export class LoaderService {
  private loaderShowRequests = 0;
  private showHideLoaderSource = new Subject<boolean>();
  public showHideLoader$ = this.showHideLoaderSource.asObservable();

  showHideLoader(status: boolean) {
    this.loaderShowRequests += status ? 1 : -1;
    if (this.loaderShowRequests < 0) {
      this.loaderShowRequests = 0;
    }
    if (this.loaderShowRequests === 1) {
      this.showHideLoaderSource.next(true);
    }

    if (this.loaderShowRequests === 0) {
      this.showHideLoaderSource.next(false);
    }
  }
}
